import { createContext } from 'react'

import type { State, Dispatch } from '../state'

export const closingReqContext = createContext<
  [state: State, dispatch: Dispatch] | undefined
>(undefined)
